import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useShowLal } from '@openx/components-segment/lib/utils/useShowLal.ts';
import { useTranslation } from 'react-i18next';

import { useSegmentListTabs } from '../hooks/useSegmentListTabs.ts';
import { type SegmentsListTabs, segmentsListTabs } from '../types.ts';

interface Props {
  onTabChange?: (tab: SegmentsListTabs) => void;
}

export const SegmentsTabs = ({ onTabChange }: Props) => {
  const { t } = useTranslation();
  const { activeTab, changeTab } = useSegmentListTabs();

  const showLal = useShowLal();

  return (
    <Tabs
      data-test="segments-list-tabs"
      onChange={(event, value) => {
        onTabChange?.(value);
        changeTab(event, value);
      }}
      value={activeTab}
    >
      <Tab
        data-test="audience-segments-tab"
        label={t('Audience Segments')}
        value={segmentsListTabs.AUDIENCE_SEGMENTS}
      />
      {showLal && (
        <Tab data-test="lookalike-segments-tab" label={t('LAL Segments')} value={segmentsListTabs.LOOKALIKE_SEGMENTS} />
      )}
    </Tabs>
  );
};
